import type { ButtonHTMLAttributes } from "react";
import { useSession } from "../session/SessionProvider.tsx";
import { deviceLabel, deviceName, deviceStatusLabel, isDeviceOnline, type Device } from "./devices.ts";
import styles from "./DeviceOption.module.css";

type DeviceOptionProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & { device: Device };

/**
 * User / Selectable (Figma 313:1856, 313:1858): аватар-буква, название, роль и точка online-статуса.
 * Выбранной кнопку делает вызывающий: `aria-current` в списке E-va, `aria-pressed` в compose.
 */
export function DeviceOption({ device, className, ...rest }: DeviceOptionProps) {
  const { user } = useSession();
  const name = deviceName(device);
  const label = deviceLabel(device, user?.id);
  return (
    <button
      type="button"
      aria-label={`${label}, ${deviceStatusLabel(device)}`}
      {...rest}
      className={[styles.option, className].filter(Boolean).join(" ")}
    >
      <span className={styles.avatar} aria-hidden="true">
        {[...name][0]?.toUpperCase()}
      </span>
      <span className={styles.text}>
        <span className={styles.name}>{label}</span>
        <span className={styles.role}>{device.ownerId === user?.id ? "Владелец" : "Гость"}</span>
      </span>
      <span className={isDeviceOnline(device) ? `${styles.dot} ${styles.online}` : styles.dot} />
    </button>
  );
}
